import React, {useState, useEffect} from 'react';
import Box from '../box/box.jsx';
import styles from './custom-instruction-viewer.css';
import iframeCommunication from '../../lib/iframe-communication.js';

const CustomInstructionViewerComponent = ({ isDragging }) => {
    const [htmlContent, setHtmlContent] = useState(null);

    // Method to set HTML content directly
    const setHTMLContent = (data) => {
        setHtmlContent(data);
    };

    useEffect(() => {
        // Set component reference in iframe communication
        iframeCommunication.setInstructionViewerComponent({ setHTMLContent });

        return () => {
            // Clean up reference
            iframeCommunication.setInstructionViewerComponent(null);
        };
    }, []);

    return (
        <Box className={`${styles.content} custom-instruction-viewer`}>
            {htmlContent ? (
                <div
                    className={styles.htmlContent}
                    style={{ pointerEvents: isDragging ? 'none' : 'auto' }}
                    dangerouslySetInnerHTML={{ __html: htmlContent.data.html }}
                />
            ) : (
                <div className={styles.loading}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        color: '#666',
                        fontSize: '14px'
                    }}>
                        <div style={{ marginBottom: '8px' }}>📚</div>
                        <div>教材を読み込み中...</div>
                    </div>
                </div>
            )}
        </Box>
    );
};

export default CustomInstructionViewerComponent;